import { string } from 'prop-types';

import Tooltip from 'components/common/Tooltip';

import { Container, Projects } from './styles';

const ProjectList = ({ projects }) => (
  <>
    <Container data-tooltip-id="projects-tooltip" data-tooltip-content={projects}>
      {projects}
    </Container>
    <Tooltip
      id="projects-tooltip"
      place="top"
      variant="light"
      render={({ activeAnchor }) => (
        <Projects>{activeAnchor?.getAttribute('data-tooltip-content')}</Projects>
      )}
    />
  </>
);

ProjectList.propTypes = {
  projects: string
};

export default ProjectList;
